import React from 'react';
import MatTextField from '@material-ui/core/TextField';

const TextField = (props) => {
    props = { ...defaultProps, ...props };
    return <MatTextField {...props} />;
}

const defaultProps = {
    fullWidth: true,
    margin: 'none'
}

export default TextField;
